// Reporte Utilidad Tiendas: solo lo ven estos usuarios (el back valida lo mismo
// en DashboardsController.utilidadTiendas).
const USUARIOS_UTILIDAD_TIENDAS = [
  "661db8938f3cb5005988712b", // ISAAC SHUEKE
  "662b063a0f8e873fc0fa6096", // RAFA SHUEKE
  "613a9434225bce3df050c220", // Admin Lynqro
];

export const puedeVerUtilidadTiendas = (user) =>
  !!user && USUARIOS_UTILIDAD_TIENDAS.includes(String(user.id));
